export default __webpack_public_path__ + "static/media/Snd_TryW.c9414e0b.mp3";